export const TabList = [
  {
    label: 'all',
    value: 'all',
  },
  {
    label: 'Operation',
    value: 'Operation',
  },
  {
    label: 'Product',
    value: 'Product',
  },
  {
    label: 'System',
    value: 'System',
  },
];

export const TYPES = [' ', 'OPERATION' /* msgType: 1 业务消息 */, 'PRODUCT' /* msgType: 2 产品类型 */, 'SYSTEM' /* msgType: 3 系统类型 */];

export const ICONS = {
  OPERATION: {
    icon: 'voice',
    color: '#F8AD21',
  },
  PRODUCT: {
    icon: 'prod',
    color: '',
  },
  SYSTEM: {
    icon: 'voice',
    color: '#8D96AA',
  },
};
